import { OnboardingMetricController } from '../../../onboarding';
import { ApplicationEntryEnhancer } from '../../../../entrypoint';
import { AnyOnboardingTrackingEvent } from '../trackingOnboardingEvent';

export function createTrackingOnboardingMetricStrategy(): ApplicationEntryEnhancer {
    return (create) => (config) => {
        function useTracker() {
            const tracker = instance.infra.useTracker<AnyOnboardingTrackingEvent>();
            return tracker;
        }

        function enhanceController(
            controller: OnboardingMetricController
        ): OnboardingMetricController {
            return {
                ...controller,
                useProps(...args) {
                    const [context, data, form] = args;
                    const tracker = useTracker();
                    const viewProps = controller.useProps(...args);
                    return {
                        ...viewProps,
                        getFormProps() {
                            const base = viewProps.getFormProps();
                            return {
                                ...base,
                                async onSubmit(...args) {
                                    const submitted = await base.onSubmit(...args);
                                    tracker.track(
                                        'onboarding_metric_selection_submitted',
                                        {
                                            metric_definition_ids: Object.keys(
                                                form.getValues().selected
                                            ),
                                        }
                                    );
                                    return submitted;
                                },
                            };
                        },
                    };
                },
            };
        }

        const instance = create({
            ...config,
            controller: {
                ...config.controller,
                onboarding: {
                    ...config.controller.onboarding,
                    createMetric(...args) {
                        const controller = config.controller.onboarding.createMetric(
                            ...args
                        );
                        return enhanceController(controller);
                    },
                },
            },
        });

        return instance;
    };
}
